import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { OrderService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { LayoutUtilsService } from '@app/core/_base/crud';

@Component({
  selector: 'meu-vat-config',
  templateUrl: './vat-config.component.html',
  styleUrls: ['./vat-config.component.scss'],
})
export class VatConfigComponent implements OnInit {
  constructor(
    private orderService: OrderService,
    private toastr: ToastrService,
    private changeDetectorRef: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService
  ) {}

  vatValue = 0;

  ngOnInit() {
    this.orderService.apiOrdersVatConfigGet().subscribe((res) => {
      if (res && res.success) {
        this.vatValue = res.data || 0;
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.changeDetectorRef.detach();
  }

  validateValue(event) {
    const value = parseFloat(event.target.value);
    event.target.value = isNaN(value) ? '' : value;
  }

  saveVat() {
    if (this.vatValue < 0 || this.vatValue > 100) {
      this.toastr.warning('Giá trị VAT không hợp lệ');
      return;
    }

    const action = 'Xác nhận';
    const title = 'Thay đổi VAT';
    const description = `Bạn có chắc chắn thay đổi giá trị VAT thành ${this.vatValue}%?`;
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.updateElement(
      action,
      '',
      title,
      description,
      waitDesciption
    );

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.orderService.apiOrdersVatConfigPut(this.vatValue).subscribe((res) => {
          if (res && res.success) {
            this.vatValue = res.data || 0;
            this.toastr.success('Lưu thành công');
            this.changeDetectorRef.detectChanges();
          } else {
            this.toastr.success('Đã xảy ra lỗi');
          }
        });
      }
    });
  }
}
